module.exports = __webpack_public_path__ + "img/phone1.87671297.svg";